<template>
  <div class="coupon-item" :style="`background-image:url(${images.bg_coupon_item});`">
    <div class="coupon-item__left">
      <template v-if="data.couponType === 'DC' ">
        <span class="amount">{{ priceDC(data.price)}}</span>
        <span class="unit">折</span>
      </template>
      <template v-else>
        <span class="unit">￥</span>
        <span class="amount">{{data.price}}</span>
      </template>
    </div>
    <div class="coupon-item__right">
      <p class="name">{{ data.couponRulesName || "" }}</p>
      <p class="description">{{ data.couponRulesDescribe || "" }}</p>
      <p class="time">有效期至
        <template v-if="data.expirationDateType === 1">{{`领取后${data.activeDay}天内`}}</template>
        <template v-else>{{data.endTime | toDate("YYYY-MM-DD HH:mm:ss")}}</template>
      </p>
    </div>
    <coupon-fixed-tag>
      <slot name="tag"></slot>
    </coupon-fixed-tag>
  </div>
</template>

<script>
import CouponFixedTag from "../couponPopover/couponFixedTag";
export default {
  name: "couponItem",
  components: {CouponFixedTag},
  props:{
    data:{
      type:Object,
      default:()=>({}),
    },
  },
  data(){
    const ossPath = this.ossPath;
    return {
      images:{
        bg_coupon_item: ossPath + "/pages/home/coupon/bg_coupon_item.png",
      },
    }
  },
  methods:{
    /**
     * 折扣比例
     */
    priceDC(price){
      return Math.round(price * 1000)/100;
    },
  },
}
</script>

<style scoped lang="scss">
.coupon-item{
  box-sizing: border-box;
  //width: 100%;
  width: 284px;
  height: 78px;
  display: flex;
  align-items: center;
  position: relative;
  border-radius: 3px;
  &__left{
    width: 88px;
    margin-right: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: inherit;
    font-weight: bold;
    color: #E75250;
    .unit{
      font-size: 16px;
    }
    .amount{
      font-size: 24px;
    }
    .amount + .unit{
      margin-left: 6px;
    }
  }
  &__right{
    padding: 0 10px;
    flex: 1;
    overflow: hidden;
    border-radius: inherit;
    .time,
    .description,
    .name{
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .name{
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }
    .description{
      font-size: 14px;
      font-weight: 500;
      color: #999999;
    }
    .time{
      font-size: 12px;
      font-weight: 500;
      color: #999999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// common/couponPopover/couponItem.vue